export class Wallet {
    public id: number;
    public amount: number;
    public date: Date;
    
    constructor() {
   
    }
  
  }  